/**
 * The set of book navigation tabs. The string values mirror the INK API's
 * publication navigation `type` (see {@link NavigationInterface}); a custom
 * navigation item has no `type` and is identified by its `key` instead.
 */
export enum BookTabEnum {
  LESSON = 'lesson',
  PRACTICE = 'practice',
  LEARNING_PLAN_GOALS = 'lpg',
  PROJECTS = 'projects',
  MANAGE_PRACTICE = 'manage_practice',
  DIGITAL_WORKBOOK = 'digital_workbook',
  EVALUATIONS = 'evaluations',
  KAI = 'kai',
  DIGITAL_WORKBOOK_PREVIEW = 'digital_workbook_preview',
  ADDITIONAL_BOOK = 'additional_book',
  ADAPTIVE = 'adaptive',
  GAME_CORNER = 'game_corner',
  LEARNING_PATH = 'learning_path',
  IMAGE_DICTIONARY = 'image_dictionary',
}
